import { getFullUrl } from 'hubspot-url-utils';
import { isLocalDeployment, isQaDeployment, isDebugEnabled } from 'usage-tracker-core/client/browserHelper';
import reportError from 'usage-tracker-core/client/reportError';
import reportWarning from 'usage-tracker-core/client/reportWarning';
import sendBeacon from 'usage-tracker-core/client/sendBeacon';
import { sendEventsViaFetch } from 'usage-tracker-core/client/fetchClient';
import { getDeviceId } from 'usage-tracker-core/common/defaultTrackers';
import { ensureFn } from 'usage-tracker-core/common/helpers';
import { createClient } from 'usage-tracker-core';
import { DEFAULT_TRACK_ENDPOINT } from 'usage-tracker-core/constants';
import { SENTRY_FINGERPRINT } from '../constants';
export const getTrackingClient = options => {
  const shouldLog = isLocalDeployment || isQaDeployment || isDebugEnabled;
  const dependencies = {
    clientName: 'quartz',
    getDebug: () => isDebugEnabled,
    getTempStorage: options.storage.getItem,
    setTempStorage: options.storage.setItem,
    logWarning: shouldLog ? console.warn : () => {},
    logError: shouldLog ? console.error : () => {},
    reportWarning,
    reportError,
    getLang: () => options.user.lang,
    getEmail: () => options.user.email,
    getHubId: () => options.user.hubId,
    getHstc: () => options.user.hstc,
    send: ({
      events,
      query = '',
      onFailure
    }) => {
      var _options$onSendEvents, _options$onSendEvents2;
      const origin = getFullUrl('app-api');
      const endpoint = `${origin}${DEFAULT_TRACK_ENDPOINT}?${query}`;
      const data = (_options$onSendEvents = (_options$onSendEvents2 = options.onSendEventsHook) === null || _options$onSendEvents2 === void 0 ? void 0 : _options$onSendEvents2.call(options, events)) !== null && _options$onSendEvents !== void 0 ? _options$onSendEvents : events;
      const handleRequestFailure = error => {
        reportError(error, {
          fingerprint: SENTRY_FINGERPRINT
        });
        ensureFn(onFailure)();
      };
      const sendXhr = () => {
        sendEventsViaFetch(endpoint, {
          data
        }).catch(handleRequestFailure);
      };
      sendBeacon(endpoint, data, sendXhr);
    }
  };

  // Create the Tracking Client and expose it
  const _client = createClient(dependencies);

  // Wire the getDeviceId to the right storage based on the Client
  const _getDeviceId = () => getDeviceId(options.storage);
  return {
    createTracker: _client.createTracker,
    getDeviceId: _getDeviceId
  };
};